import { resourceExplorerWidgetSelector } from "../current-resource-explorer/resource-explorer-widget/resourceExplorerWidgetSelector";
import { RootState } from "../../../store";

export const resourceExplorerWidgetDataLoadingSelector = (
  state: RootState,
): boolean | undefined => {
  return resourceExplorerWidgetSelector(state)?.isLoading;
};
